export default {
  chat: Object.freeze({
    APP_USER_CHAT: 'app-user-chat', APP_PATIENT_CHAT: 'app-patient-chat', APP_MIMIRMAN_CHAT: 'app-mimirman-chat'
  }),
}
